import styled from 'styled-components';

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	margin: 30px 20px;
	gap: 30px;
`;

export const Column = styled.div`
	display: flex;
	flex-direction: column;
	gap: 5px;
`;

export const Row = styled.div<{ gap?: string }>`
	display: flex;
	gap: ${({ gap }) => gap || '5px'};
`;
